<template>
  <div>
    <div class="apply-title">
      申请成为开发者
    </div>
    <form class="apply-form" ref="applyForm">
      <div class="form-group">
        <label class="name-label"><span class="text-red">*</span>姓名</label>
        <div class="controls">
          <div class="input-div">
            <input type="text" autocomplete="off" class="form-control" placeholder="姓名" v-model="username" @input="checkUsername">
            <span class="apply-tip">建议填写您的公司名称/真实姓名</span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="name-label"><span class="text-red">*</span>联系电话</label>
        <div class="controls">
          <div class="input-div">
            <input type="text" autocomplete="off" class="form-control" placeholder="联系电话" v-model="phone" @input="checkPhone">
            <span class="apply-tip">填写您的联系方式，用于接收审核结果和通知</span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="name-label"><span class="text-red">*</span>验证码</label>
        <div class="controls">
          <div class="input-div">
            <input type="text" autocomplete="off" class="form-control" style="width: 40%;float: left;" placeholder="验证码" v-model="code" @input="checkCode">
            <span class="code-span">
              <span class="get-code" v-show="!showCountDown" @click="getCode">获取验证码</span>
              <span class="get-code" v-show="showCountDown">重新发送({{countDown}})s</span>
            </span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="name-label">申请理由</label>
        <div class="controls">
          <div class="input-div">
            <textarea style="width: 100%;" rows="4" v-model="reason" @input="checkReason" v-bind:maxlength="surplus"  v-on:input="reasonNum()" v-on:compositionstart="importStart()" v-on:compositionend="importEnd()"></textarea>
            <span class="apply-tip">描述您的使用场景，200个字符以内</span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="name-label"></label>
        <div class="controls">
          <input type="checkbox" value="1" v-model="agreement"> 我已阅读并同意<span class="agreement">《用户协议》</span>
        </div>
      </div>
      <div class="form-group">
        <label class="name-label"></label>
        <div class="controls">
          <button type="button" class="btn-apply" @click="summitData">立即申请</button>
        </div>
      </div>
    </form>
    <Login :isNeedLogin="showLogin" @change="changeShowLogin" @login="loginSuccess"></Login>
    <Dialog width="300px" :visible.sync="dialogTipVisible" :message="tip_msg" :loading.sync="loading" dialogType="message"></Dialog>
    <Dialog width="350px" :title.sync="alert_title" :visible.sync="dialogAlertVisible" :message="alert_msg" dialogType="alert" :beforeClose="beforeCloseFunc"></Dialog>
  </div>
</template>
<script>
import Login from '@/components/document/user/Login'
import Dialog from '@/components/Dialog'
import { myAppIndex } from '@/api/promotion'
import { applyDeveloperSms,applyDeveloper } from '@/api/user'
export default {
  name: 'Apply',
  components: {
    Login,
    Dialog
  },
  data() {
    return{
      username: undefined,
      phone: undefined,
      code: undefined,
      reason: undefined,
      agreement: 0,
      loading: false,
      isDoing: false,
      showCountDown: false,
      countDown:60,
      isNeedLogin: true,
      showLogin: false,
      tip_msg: undefined,
      dialogTipVisible: false,
      alert_title: '提示',
      alert_msg: undefined,
      dialogAlertVisible: false,
      beforeCloseFunc: Function,
      surplus: 200,
      conterNum: 0,
    }
  },
  created(){

  },
  methods: {
    //获取验证码
    getCode() {
      if (this.isLock()) {
        return;
      }
      let that = this
      this.tip_msg = undefined
      if (!this.checkUsername() || !this.checkPhone()) {
        this.message(this.tip_msg)
        return;
      }
      this.lock()
      this.showCountDown = true
      this.countDown = 60
      applyDeveloperSms().then(response => {
        this.unlock()
        this.$Message.success(response.message)
        this.timer = setInterval(()=>{
          this.countDown--
          if(this.countDown === 0){
            this.showCountDown = false
            clearInterval(this.timer)
          }
        },1000)
      }).catch(error => {
        console.log(error)
        this.unlock()
        this.showCountDown = false
      })
    },
    // 立即申请
    summitData() {
      if (this.isLock()) {
        return;
      }
      if(!this.checkUsername() || !this.checkPhone() || !this.checkCode() || !this.checkAgreement()){
        this.message(this.tip_msg)
        return;
      }
      this.lock();
      applyDeveloper({
        relation_name:this.username,
        relation_mobile:this.phone,
        apply_reason:this.reason,
        code:this.code,
      }).then(response => {
        this.unlock()
        this.$Message.success(response.message)
        this.$emit('onSuccess',2);
        //更新用户信息
        this.$store.dispatch('user/getInfo')
      }).catch(error => {
        this.unlock()
        console.log(error)
        this.showCountDown = false
      })
    },
    lock() {
      this.isDoing = true;
    },
    unlock() {
      this.isDoing = false;
    },
    isLock() {
      return this.isDoing
    },
    // 校验姓名
    checkUsername() {
      if(!this.username || this.username === '') {
        this.tip_msg = '姓名不能为空'
        return false
      } else if (this.username.length > 32){
        this.tip_msg = '用户名1~32个字符'
        return false
      }
      return true
    },
    // 校验联系电话
    checkPhone() {
      if(!this.phone || this.phone === '') {
        this.tip_msg = '手机号不能为空'
        return false
      } else if (!/^1[3-9]\d{9}$/.test(this.phone)){
        this.tip_msg = '请填写正确的手机号'
        return false
      }
      return true
    },
    // 校验验证码
    checkCode() {
      if(!this.code || this.code === '') {
        this.tip_msg = '验证码不能为空'
        return false
      }
      return true
    },
    // 校验申请理由
    checkReason() {
      if (!this.reason){
        this.tip_msg = '请输入申请理由'
        return false
      }
      return true
    },
    //校验用户协议
    checkAgreement(){
      if(!this.agreement){
        this.message('请先阅读并同意用户协议')
        return false
      }
      return true
    },
    // 关闭登录弹窗回调
    changeShowLogin(value){
      this.showLogin = value
    },
    // 登录成功回调
    loginSuccess() {
      this.isNeedLogin = false
    },
    // 文本提示
    message(msg){
      this.tip_msg = msg
      this.dialogTipVisible = true
    },
    // 弹窗提示
    alert(title, msg, func = Function){
      this.alert_title = title
      this.alert_msg = msg
      this.dialogAlertVisible = true
      this.beforeCloseFunc = func
    },
    //textarea字数监控
    reasonNum() {
      let self = this;
      if (self.cInput == false) {
        self.conterNum = self.reason.length;
      }
    },
    importStart() {
      this.cInput = true;
    },
    importEnd() {
      this.cInput = false;
      //this.write();
    },
  },
}
</script>

<style scoped>
.apply-title{
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  padding: 25px 0;
  margin-left: 25px;
  border-bottom: 1px solid #cccccc;
  width: 70%;
}
.apply-form{
  max-width: 450px;
  margin-left: 20%;
  margin-top: 50px;
}
.form-group{
  position: relative;
  overflow: hidden;
  width: 100%;
  margin-bottom: 0;
}
.form-group::before,.form-group::after{
  content: " ";
  display: table;
  box-sizing: border-box;
}
.name-label {
  width: 20%;
  float: left;
  text-align: right;
  color: #222222;
  font-size: 13px;
  font-weight: normal;
  line-height: 30px;
  padding-right: 10px;
}
.controls{
  overflow: hidden;
  margin-left: 20%;
  margin-bottom: 15px;
}
.text-red {
  color: #e74c3c !important;
  padding-right: 5px
}
.input-div {
  width: 80%;
  float: left;
}
.form-control {
  border-color: #666666;
  height: 33px;
  box-shadow: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: block;
  width: 100%;
  padding: 6px 12px;
  font-size: 12px;
  line-height: 1.42857143;
  color: #555555;
  background-color: #fff;
  border: 1px solid #ccc;
}
input{
  font: inherit;
  margin: 0;
}
.apply-tip {
  position: relative;
  top: 2px;
  color: #999999;
}
.get-code {
  display: block;
  float: right;
  text-align: center;
  background: #FFFFFF;
  color: #199ED8;
  width: 100px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #199ED8;
  border-radius: 4px;
  cursor: pointer;
}
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  overflow: auto;
  color: inherit;
  font: inherit;
  margin: 0;
  border: 1px solid #cccccc;
}
.agreement{
  color: #0e90d2;
  cursor: pointer;
}
.btn-apply{
  border-radius: 4px;
  background: #199ED8;
  color: #FFFFFF;
  padding: 10px 16px;
  font-size: 15px;
  line-height: 1.3333333;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/document/user/Apply.vue